/* ==========================================================================
   LMRT 定制脚本
   通过 snippets/custom-assets.liquid 中 useCustomScript = true 启用
   ========================================================================== */

/* 侧栏 Collapsible 菜单：展开一个父级时自动折叠其他已展开的父级。
   由 main-sidebar → Main menu 区块的 "Auto-collapse other menus" 勾选项控制，
   开启后 menu.liquid 会在 <menu-dropdown> 上输出 data-auto-collapse。
   实现方式：程序化“点击”其他已展开父级的切换图标，完全复用主题自身的
   toggleCollapsibleMenu 逻辑（open 类、maxHeight 动画、tabindex、二级重置），
   不复制任何状态代码。程序化点击再次进入本监听时，因该项已变为收起态而
   直接 return，不会递归。 */
(() => {
  const collapseSiblings = (icon) => {
    const dropdown = icon.closest('menu-dropdown[data-auto-collapse]');
    if (!dropdown) return;

    const current = icon.closest('.menu__item-title--collapsible');
    // 主题的切换处理器绑定在图标元素上，先于本监听执行；
    // 此时 open 类已反映新状态——若刚被收起则无需处理。
    if (!current || !current.classList.contains('open')) return;

    dropdown.querySelectorAll('.menu__item-title--collapsible.open').forEach((other) => {
      if (other === current) return;
      other.querySelector('.dropdown-icon--first-level')?.click();
    });
  };

  document.addEventListener('click', (event) => {
    const icon = event.target.closest?.('.menu__item-title--collapsible .dropdown-icon--first-level');
    if (icon) collapseSiblings(icon);
  });

  document.addEventListener('keyup', (event) => {
    if (event.code?.toUpperCase() !== 'ENTER') return;
    const icon = event.target.closest?.('.menu__item-title--collapsible .dropdown-icon--first-level');
    if (icon) collapseSiblings(icon);
  });
})();
